import { Autocomplete, Box, Checkbox, Chip, CircularProgress, FormControlLabel, FormGroup, FormLabel, Grid, ListItem, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import { memo, useRef } from "react";
import { useSelector } from 'react-redux';
import CustomInput from "../../components/inputs/CustomInputs";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import { CenteredBox } from "../../components/layouts/OneViewBox";
import { STATUS, USER_ROLES, PAYMENT_METHOD, CANCEL_PAYMENT } from "../../utils/constants";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import moment from "moment";
import { titleCase } from "../../utils/main";
import { getProdutApi } from "../../apis/product.api";
import AsyncDropDown from "../../components/inputs/AsyncDropDown";
import PaddingBoxInDesktop from "../../components/layouts/PaddingBoxDesktop";
import { getsourceApi } from "../../apis/source.api";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import FileInput from "../../components/upload/FileInput";


const UpdateCreateQueryUi = ({ listItem, validation, selectedDispatch, listProblem, statusPass, setArrr, arrr, title, isOtp, productAccessories, modalKey, isUpdate, fields, setFields, loading, onSubmit, setVariant, variant1 }) => {
    const user = useSelector(state => state.user)

    return (
        <>
            {!isOtp && <CustomDialog
                id={`UpdateQuery`}
                loading={loading}
                err={fields.err}
                onSubmit={onSubmit}
                title={` Update ${title}`}
                closeText="Close"
                confirmText={`Update`}
            >
                {loading ? (
                    <CenteredBox><CircularProgress /></CenteredBox>
                ) : (
                    <>
                        <Box width={"90%"} display={"flex"} flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
                            <Box display={"flex"} flexDirection={"column"}>
                                <Typography>
                                    Ticket Number: {fields?.ticket_no}
                                </Typography>
                            </Box>
                            <Box display={"flex"} flexDirection={"column"}>
                                <Typography>
                                    Date: {moment(fields?.createdAt).format("DD/MM/YYYY")}
                                </Typography>
                            </Box>
                        </Box>
                        <Box mt={3} width={"100%"}>
                            <Box mt={1} gap={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                <AsyncDropDown
                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    defaultVal={
                                        fields.product_id?._id ? {
                                            _id: fields.product_id?._id,
                                            name: fields.product_id?.name,
                                        } : null
                                    }
                                    lazyFun={async (para) => await getProdutApi({ ...para, allStatus: true })}
                                    OptionComponent={({ option, ...rest }) => {
                                        return <ListItem {...rest}>{option.name}</ListItem >
                                    }}
                                    onChange={async (changedVal) => {
                                        setFields({ ...fields, product_id: changedVal ? changedVal._id : null, })
                                    }}
                                    titleKey={'name'}
                                    valueKey={"_id"}
                                    InputComponent={(params) => <CustomInput placeholder={"Select Product"} {...params} margin="none" />}
                                />
                                <CustomInput
                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    value={fields.box_id}
                                    onChange={(e) => setFields({ ...fields, err: '', box_id: e.target.value })}
                                    type="text"
                                    label={" Box Id.*"}
                                />
                            </Box>
                            <Box mt={1} gap={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                <CustomInput
                                    autoFocus={true}
                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    value={fields.customer_name}
                                    onChange={(e) => setFields({ ...fields, err: '', customer_name: e.target.value })}
                                    type="text"
                                    label={"Customer Name*"}
                                />
                                <CustomInput

                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    value={fields.customer_phone}
                                    onChange={(e) => setFields({ ...fields, err: '', customer_phone: e.target.value })}
                                    type="number"
                                    label={" Phone No.*"}
                                />
                            </Box>

                            <Box gap={3} mb={1} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                <CustomInput
                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    value={fields.country?.name}
                                    onChange={(e) => setFields({ ...fields, err: '', country: e.target.value })}
                                    type="text"
                                    label={"Country*"}
                                />
                                <CustomInput
                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    value={fields.state?.name}
                                    onChange={(e) => setFields({ ...fields, err: '', state: e.target.value })}
                                    type="text"
                                    label={"State*"}
                                />
                                <CustomInput
                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    value={fields.city?.name}
                                    onChange={(e) => setFields({ ...fields, err: '', city: e.target.value })}
                                    type="text"
                                    label={"City*"}
                                />
                            </Box>

                            <Box gap={3} mt={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                <Autocomplete
                                    disabled={statusPass !== STATUS.EVALUATION}
                                    // value={listProblem?.filter(problem => fields.problems.includes(problem.name)) || []}
                                    value={
                                        listProblem?.filter(problem =>
                                            fields.problems.some(p => p.toLowerCase() === problem.name.toLowerCase())
                                        ) || []
                                    }
                                    sx={{ width: "100%", color: "primary.main" }}
                                    multiple
                                    onChange={(event, newValue) => {
                                        setFields({
                                            ...fields,
                                            err: "",
                                            problems: newValue.map((val) => val?.name),
                                        });
                                    }}
                                    options={listProblem ?? []}
                                    getOptionLabel={(option) => option.name}
                                    renderTags={(tagValue, getTagProps) =>
                                        tagValue.map((option, index) => (
                                            <Chip label={option.name} {...getTagProps({ index })} />
                                        ))
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            margin="dense"
                                            {...params}
                                            label="Problems*"
                                            variant="outlined"
                                            placeholder="Select Problems"
                                        />
                                    )}
                                />

                                {fields?.problems?.map((item) =>
                                (item.toLowerCase() === "other" && <CustomInput
                                    disabled={statusPass !== STATUS.EVALUATION}
                                    value={fields.other}
                                    onChange={(e) => setFields({ ...fields, err: '', other: e.target.value })}
                                    type="text"
                                    label={" Other Problems"}
                                />
                                ))}
                            </Box>
                            {statusPass === STATUS.PENDING_EVALUATION && <FormControl >
                                <FormGroup row>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                onChange={(e) => {
                                                    setFields({
                                                        ...fields,
                                                        err: "",
                                                        status: [

                                                            {
                                                                status_role: STATUS.EVALUATION,
                                                                role: USER_ROLES.CRM_TEAM
                                                            },
                                                            {
                                                                status_role: STATUS.EVALUATION,
                                                                role: USER_ROLES.LD
                                                            }
                                                        ]
                                                    });
                                                }}
                                            />
                                        }
                                        label=" Start Evalution"
                                        labelPlacement="end"
                                    />
                                </FormGroup>
                            </FormControl>}

                            {statusPass === STATUS.EVALUATION && <>
                                <Box gap={3} mt={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                    <Autocomplete

                                        value={productAccessories?.filter(accessories => fields.product_accessories.includes(accessories.name)) || []}
                                        sx={{ width: "100%", color: "primary.main" }}
                                        multiple
                                        onChange={(event, newValue) => {
                                            setFields({
                                                ...fields,
                                                err: "",
                                                product_accessories: newValue.map((val) => val?.name),
                                            });
                                        }}
                                        options={productAccessories ?? []}
                                        getOptionLabel={(option) => option.name}
                                        renderTags={(tagValue, getTagProps) =>
                                            tagValue.map((option, index) => (
                                                <Chip label={option.name} {...getTagProps({ index })} />
                                            ))
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                margin="dense"
                                                {...params}
                                                label="Product Accessories*"
                                                variant="outlined"
                                                placeholder="Selected Product Accessories*"
                                            />
                                        )}
                                    />
                                </Box>
                                <DesktopDatePicker
                                    label="Purchase Date*"
                                    disableFuture
                                    inputFormat="DD/MM/yyyy"
                                    renderInput={(props) => <CustomInput {...props} />}
                                    autoFocus={true}
                                    disabled={loading}
                                    minDate={fields?.manufacturer_date ? moment(fields.manufacturer_date) : undefined}
                                    maxDate={moment()}
                                    value={fields?.warrenty_date ? moment(fields?.warrenty_date) : null}
                                    onChange={(val) => {
                                        if (val && val.isValid()) {
                                            const isoString = val.toISOString();
                                            setFields({
                                                ...fields,
                                                err: "",
                                                warrenty_date: isoString,
                                            });
                                        } else {
                                            setFields({
                                                ...fields,
                                                err: "",
                                                warrenty_date: "",
                                            });
                                        }
                                    }}
                                />

                                <Box>
                                    <Grid xs={12} md={6} item>
                                        <Box>
                                            <FileInput
                                                multi
                                                onDelete={(filesToDelete) => {
                                                    setFields((prevFields) => ({
                                                        ...prevFields,
                                                        err: "",
                                                        unbox_photo: fields.unbox_photo.filter(file => !filesToDelete.includes(file))
                                                    }));
                                                }}
                                                onChange={(newFiles) => {
                                                    setFields((prevFields) => ({
                                                        ...prevFields,
                                                        err: "",
                                                        unbox_photo: [...fields.unbox_photo, newFiles]
                                                    }));
                                                }}
                                                defaults={fields?.unbox_photo ?? []}
                                                accept="image/*,.pdf"
                                                title="Device Photos"
                                                subTitle="Only png, jpeg, jpg, pdf files are allowed! Less than 1 MB"
                                            />

                                        </Box>
                                    </Grid>
                                </Box>
                                <Box mt={3}>
                                    <FormControl >

                                        <FormGroup component="fieldset" row>

                                            {statusPass === STATUS.EVALUATION && <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={fields.conclusion === "send_for_repair"}
                                                        onChange={(e) => {
                                                            setFields({
                                                                ...fields,
                                                                err: "",
                                                                conclusion: e.target.name,
                                                                status: [

                                                                    {
                                                                        status_role: STATUS.DEVICE_RECEIVED,
                                                                        role: USER_ROLES.REPAIR_TEAM
                                                                    }
                                                                    , {
                                                                        status_role: STATUS.SEND_TO_REPAIR,
                                                                        role: USER_ROLES.CRM_TEAM
                                                                    }, {
                                                                        status_role: STATUS.SEND_TO_REPAIR,
                                                                        role: USER_ROLES.LD
                                                                    }
                                                                ]
                                                            });
                                                        }}
                                                        name="send_for_repair"
                                                    />
                                                }
                                                label="Send to Repair Team"
                                                labelPlacement="end"
                                            />}
                                        </FormGroup>
                                    </FormControl>
                                </Box>


                            </>}
                            {statusPass === STATUS.WAITING_FOR_PAYMENT && <Box mt={2}>
                                <DesktopDatePicker
                                    disableFuture

                                    inputFormat="DD/MM/yyyy"
                                    renderInput={(props) => <CustomInput {...props} />}
                                    autoFocus={true}
                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    label="Purchase Date"
                                    value={fields?.warrenty_date ? moment(fields?.warrenty_date) : null}
                                    onChange={(val) => {
                                        if (val && val.isValid()) {
                                            const isoString = val.toISOString();
                                            setFields({
                                                ...fields,
                                                err: "",
                                                warrenty_date: isoString,
                                            });
                                        } else {
                                            setFields({
                                                ...fields,
                                                err: "",
                                                warrenty_date: "",
                                            });
                                        }
                                    }}
                                />
                                    {(fields.device_is === "physical_damage") &&
                                        <Box mt={1} gap={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                            <Autocomplete
                                                disabled={user.data.role !== USER_ROLES.ADMIN}
                                                multiple
                                                fullWidth
                                                options={listItem ?? []}
                                                value={
                                                    listItem?.filter(item =>
                                                        fields?.physical_damage?.damage_part?.some(
                                                            p => p === `${item.name} (${item.solution})`
                                                        )
                                                    ) || []
                                                }
                                                getOptionLabel={(option) => `${option.name} (${option.solution})`}
                                                onChange={(event, newValue) => {
                                                    setFields({
                                                        ...fields,
                                                        err: "",
                                                        physical_damage: {
                                                            ...fields.physical_damage,
                                                            damage_part: newValue.map((val) => `${val.name} (${val.solution})`),
                                                            repairing_amount: newValue.reduce((sum, val) => sum + (val?.price || 0), 0),
                                                        },
                                                    });
                                                }}
                                                renderTags={(tagValue, getTagProps) =>
                                                    tagValue.map((option, index) => (
                                                        <Chip
                                                            label={`${option.name} (${option.solution})`}
                                                            {...getTagProps({ index })}
                                                        />
                                                    ))
                                                }
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        margin="dense"
                                                        label="Damage Part*"
                                                        variant="outlined"
                                                        placeholder="Damage Part"
                                                    />
                                                )}
                                            />
                                            <CustomInput
                                                disabled={user.data.role !== USER_ROLES.ADMIN}
                                                value={fields?.physical_damage?.repairing_amount}
                                                onChange={(e) => setFields({ ...fields, err: '', physical_damage: { ...fields.physical_damage, repairing_amount: e.target.value } })}
                                                type="number"
                                                InputLabelProps={{ shrink: fields?.physical_damage?.repairing_amount && true }}
                                                label={"Cost*"}
                                            />
                                            <CustomInput
                                                disabled={user.data.role !== USER_ROLES.ADMIN}
                                                value={fields?.physical_damage?.remarks}
                                                onChange={(e) => setFields({ ...fields, err: '', physical_damage: { ...fields.physical_damage, remarks: e.target.value } })}
                                                type="text"
                                                label={"Remarks*"}
                                            />


                                        </Box>}
                                    {fields.device_is === "Repairable" && <Box mt={1} mb={2} gap={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                        <Autocomplete
                                            multiple
                                            fullWidth
                                            options={listItem ?? []}
                                            disabled={user.data.role !== USER_ROLES.ADMIN}
                                            value={
                                                listItem?.filter(item =>
                                                    fields?.repairable_part?.some(
                                                        p => p === `${item.name} (${item.solution})`
                                                    )
                                                ) || []
                                            }
                                            getOptionLabel={(option) => `${option.name} (${option.solution})`}
                                            onChange={(event, newValue) => {
                                                setFields({
                                                    ...fields,
                                                    err: "",
                                                    repairable_part: newValue.map((val) => `${val.name} (${val.solution})`),
                                                    repairing_amount: validation ? newValue.reduce((sum, val) => sum + (val?.price || 0), 0) : null
                                                });
                                            }}
                                            renderTags={(tagValue, getTagProps) =>
                                                tagValue.map((option, index) => (
                                                    <Chip
                                                        label={`${option.name} (${option.solution})`}
                                                        {...getTagProps({ index })}
                                                    />
                                                ))
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    margin="dense"
                                                    label="Damage Part*"
                                                    variant="outlined"
                                                    placeholder="Damage Part"
                                                />
                                            )}
                                        />
                                        {validation && <CustomInput
                                            InputLabelProps={{ shrink: fields?.repairing_amount && true }}
                                            disabled={user.data.role !== USER_ROLES.ADMIN}
                                            value={fields?.repairing_amount}
                                            onChange={(e) => setFields({ ...fields, err: '', repairing_amount: e.target.value })}
                                            type="number"
                                            label={"Cost*"}
                                        />}
                                        <CustomInput

                                            disabled={user.data.role !== USER_ROLES.ADMIN}

                                            value={fields?.repairable_remarks}
                                            onChange={(e) => setFields({ ...fields, err: '', repairable_remarks: e.target.value })}
                                            type="text"
                                            label={"Remarks*"}
                                        />

                                    </Box>}
                                <FormControl fullWidth>
                                    <InputLabel>Pending Payment*</InputLabel>
                                    <Select
                                        value={fields.repairing_amount_status}
                                        label="Pending Payment"
                                        onChange={(e) => {
                                            setFields({
                                                ...fields,
                                                err: '',
                                                repairing_amount_status: e.target.value,

                                            });
                                        }}
                                    >
                                        <MenuItem value={PAYMENT_METHOD.PAYMENT_RECEIVED}>{titleCase(PAYMENT_METHOD.PAYMENT_RECEIVED)}</MenuItem>
                                        <MenuItem value={PAYMENT_METHOD.CANCEL_PAYMENT}>{"Unable To Pay"}</MenuItem>
                                        {/* <MenuItem value={PAYMENT_METHOD.RETURN_DEVICE}>{titleCase(PAYMENT_METHOD.RETURN_DEVICE)}</MenuItem> */}
                                    </Select>
                                </FormControl>

                                {fields.repairing_amount_status === PAYMENT_METHOD.PAYMENT_RECEIVED && <FormControl >
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    onChange={(e) => {
                                                        setFields({
                                                            ...fields,
                                                            err: "",
                                                            status: [
                                                                {
                                                                    status_role: STATUS.PAYMENT_RECEIVED,
                                                                    role: USER_ROLES.REPAIR_TEAM
                                                                },
                                                                {
                                                                    status_role: STATUS.SEND_TO_REPAIR,
                                                                    role: USER_ROLES.CRM_TEAM
                                                                },
                                                                {
                                                                    status_role: STATUS.SEND_TO_REPAIR,
                                                                    role: USER_ROLES.LD
                                                                }

                                                            ]
                                                        });
                                                    }}
                                                />
                                            }
                                            label="Sent To Repair"
                                            labelPlacement="end"
                                        />
                                    </FormGroup>
                                </FormControl>}
                                {fields.repairing_amount_status === PAYMENT_METHOD.CANCEL_PAYMENT && <>
                                    <Box display={"flex"} flexDirection={"row"} gap={3}>
                                        <Box mt={2} display={"flex"} flexDirection={"row"} justifyContent={"flex-start"} alignItems={"center"} border={"1px solid black"} width={selectedDispatch.current === CANCEL_PAYMENT.NO ? "49.3%" : "100%"} height={"8vh"} borderRadius={"4px"} p={3}>
                                            <FormControl sx={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                                <FormLabel id="demo-radio-buttons-group-label">Customer need Devices Back ? :</FormLabel>
                                                <RadioGroup
                                                    row
                                                    sx={{ marginLeft: "10px" }}
                                                    onChange={(e) => {
                                                        const data = Number(e.target.value)
                                                        selectedDispatch.current = Number(e.target.value)
                                                        let statusdata = [];
                                                        if (data === CANCEL_PAYMENT.YES) {
                                                            statusdata = [
                                                                {
                                                                    status_role: STATUS.DISPATCH,
                                                                    role: USER_ROLES.LD,
                                                                },
                                                                {
                                                                    status_role: STATUS.DISPATCH,
                                                                    role: USER_ROLES.CRM_TEAM,
                                                                }

                                                            ];
                                                        }
                                                        setFields({
                                                            ...fields,
                                                            err: "",
                                                            status: statusdata,
                                                            Repairing_Feasible: data === CANCEL_PAYMENT.NO && true
                                                        });
                                                    }}
                                                >
                                                    {Object.keys(CANCEL_PAYMENT).map((item) => (
                                                        <FormControlLabel
                                                            disabled={loading}
                                                            key={item}
                                                            value={CANCEL_PAYMENT[item]}
                                                            control={<Radio />}
                                                            label={titleCase(item)}
                                                        />
                                                    ))}
                                                </RadioGroup>
                                            </FormControl>
                                        </Box>
                                        {selectedDispatch.current === CANCEL_PAYMENT.NO && <Box mt={2} display={"flex"} flexDirection={"row"} justifyContent={"flex-start"} alignItems={"center"} border={"1px solid black"} width={"49.3%"} height={"8vh"} borderRadius={"4px"} p={3}>
                                            <FormControl sx={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                                <FormLabel >Repairing Feasible ? :</FormLabel>
                                                <RadioGroup
                                                    row
                                                    sx={{ marginLeft: "10px" }}
                                                    onChange={(e) => {
                                                        const data = Number(e.target.value)
                                                        let statusdata = [];
                                                        if (data === CANCEL_PAYMENT.YES) {
                                                            statusdata = [
                                                                {
                                                                    status_role: STATUS.REPAIR_DEMO,
                                                                    role: USER_ROLES.REPAIR_TEAM
                                                                },
                                                                {
                                                                    status_role: STATUS.SEND_TO_REPAIR,
                                                                    role: USER_ROLES.CRM_TEAM
                                                                },
                                                                {
                                                                    status_role: STATUS.SEND_TO_REPAIR,
                                                                    role: USER_ROLES.LD
                                                                }
                                                            ]
                                                        }

                                                        if (data === CANCEL_PAYMENT.NO) {

                                                            statusdata = [
                                                                {
                                                                    status_role: STATUS.NOT_DISPATCH,
                                                                    role: USER_ROLES.CRM_TEAM,
                                                                },
                                                                {
                                                                    status_role: STATUS.NOT_DISPATCH,
                                                                    role: USER_ROLES.LD,
                                                                },
                                                                {
                                                                    status_role: STATUS.NOT_DISPATCH,
                                                                    role: USER_ROLES.REPAIR_TEAM,
                                                                }
                                                            ];
                                                        }
                                                        setFields({
                                                            ...fields,
                                                            err: "",
                                                            status: statusdata,
                                                            Repairing_Feasible: false
                                                        });
                                                    }}
                                                >
                                                    {Object.keys(CANCEL_PAYMENT).map((item) => (
                                                        <FormControlLabel
                                                            disabled={loading}
                                                            key={item}
                                                            value={CANCEL_PAYMENT[item]}
                                                            control={<Radio />}
                                                            label={titleCase(item)}
                                                        />
                                                    ))}
                                                </RadioGroup>
                                            </FormControl>
                                        </Box>}
                                    </Box>
                                    {selectedDispatch.current && (
                                        <CustomInput
                                            disabled={loading}
                                            value={fields.dispatch_remarks}
                                            onChange={(e) => setFields({ ...fields, err: '', dispatch_remarks: e.target.value })}
                                            type="text"
                                            label={"Remarks*"}
                                        />
                                    )}

                                </>}
                            </Box>
                            }
                        </Box>
                    </>
                )}
            </CustomDialog >}
        </>
    );
}

export default memo(UpdateCreateQueryUi);